/**
 * Generates options for the cancellation date description dropdown.
 * @param labels - Array of labels for the dropdown options - default is ['Now', 'Later']
 * @returns Array of objects containing value and label for each option.
 */
export const getDateDescriptionOptions = (labels: string[] = ['Now', 'Later']) =>
	labels?.map((option) => ({
		value: option.toUpperCase(),
		label: option,
	})) || [];
